import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../helpers/api';
import * as T from './actionTypes';
import { fetchAssetCostSuccess, fetchAssetCostFail } from './actions';

const errMsg = (e, fallback) => e?.response?.data?.message || fallback;

function* fetchAssetCostSaga({ payload }) {
  try {
    const { assetId, from, to, includeChildren } = payload;
    const qs = new URLSearchParams();
    qs.set('assetId', String(assetId));
    if (from) qs.set('from', from);
    if (to) qs.set('to', to);
    qs.set('includeChildren', String(includeChildren ?? true));
    const { data } = yield call(api.get, `asset-maintenance-cost?${qs.toString()}`);
    yield put(fetchAssetCostSuccess(data.response));
  } catch (error) {
    yield put(fetchAssetCostFail(errMsg(error, 'Failed to load asset cost')));
  }
}

export default function* assetCostSaga() {
  yield takeLatest(T.FETCH_ASSET_COST, fetchAssetCostSaga);
}
